export const TABLE_HEIGHT = {
  WITH_TABS_AND_ACTIONS:
    'h-full max-h-[calc(100vh-248px)] max-lg-xl:max-h-[calc(100vh-220px)]',

  WITHOUT_TABS:
    'h-full max-h-[calc(100vh-188px)] max-lg-xl:max-h-[calc(100vh-160px)]',

  ONLY_TABS:
    'h-full max-h-[calc(100vh-182px)] max-lg-xl:max-h-[calc(100vh-162px)]'
};
